import React from 'react'
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/CloseRounded'
import useContactsDetailStore from '../../store/contactsDetail'
import ContactDetailHost from './ContactDetailHost'

export interface ContactDrawerProps {
  open: boolean
  stationId: number
  contactId: number | null
  isAdmin: boolean
  onClose: () => void
  onNavigateContact: (contactId: number) => void
  onDeleted?: () => void
}

const drawerWidth = 520

const ContactDrawer: React.FC<ContactDrawerProps> = ({
  open,
  stationId,
  contactId,
  isAdmin,
  onClose,
  onNavigateContact,
  onDeleted,
}) => {
  const contactName = useContactsDetailStore(
    React.useCallback(
      (state) => (contactId ? state.byId[contactId]?.data?.contact.name ?? null : null),
      [contactId],
    ),
  )

  return (
    <Drawer
      anchor="right"
      open={open && Boolean(contactId)}
      onClose={onClose}
      hideBackdrop
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: drawerWidth },
          borderRadius: { xs: 0, sm: '24px 0 0 24px' },
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        },
        elevation: 16,
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
        <Typography variant="h6" sx={{ fontWeight: 600 }} noWrap>
          {contactName || 'Contact'}
        </Typography>
        <IconButton onClick={onClose} aria-label="Close contact drawer">
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', pr: 1 }}>
        {contactId ? (
          <ContactDetailHost
            stationId={stationId}
            contactId={contactId}
            isAdmin={isAdmin}
            onMergedRedirect={onNavigateContact}
            onDeletedRedirect={() => {
              onClose()
              onDeleted?.()
            }}
          />
        ) : null}
      </Box>
    </Drawer>
  )
}

export default ContactDrawer
